import {
  CUSTOM_FIELDS_SETTINGS_NO_CUSTOM_FIELDS_VIEW,
  CUSTOM_FIELDS_SETTINGS_NO_CUSTOM_FIELDS_EDIT_1,
  CUSTOM_FIELDS_SETTINGS_NO_CUSTOM_FIELDS_EDIT_2,
  CUSTOM_FIELDS_SETTINGS_NO_CUSTOM_FIELDS_EDIT_3,
} from 'pages/Settings/pages/CustomFields/CustomFieldsSettings.constants';
import { useCustomFieldsSettingsComponentPropsContext } from 'pages/Settings/pages/CustomFields/contexts/CustomFieldsSettingsComponent.props.context';
import {
  CustomFieldsSettingsTableStyled,
  TableRowCell,
  InlineBKJButton,
  TableRow,
  TableHeaderCell,
  TableRowCellButton,
} from 'pages/Settings/pages/CustomFields/CustomFieldsSettingsComponent/CustomFieldsSettingsComponent.styled';
import { FacilitiesTableCell } from 'pages/Settings/pages/CustomFields/CustomFieldsSettingsComponent/FacilitiesTableCell';
import { useFetchCustomFieldsDataContext } from 'pages/Settings/pages/CustomFields/contexts/FetchCustomFields.data.context';
import { Fragment } from 'react';
import { useTranslation } from 'hooks/useTranslation';
import { BKJIcon } from '@bookjane2/bookjane-design-library';
import i18next from 'i18next';

export function CustomFieldsSettingsTable() {
  const { isReadOnly, openEditCustomFieldsModal, openCreateCustomFieldsModal } =
    useCustomFieldsSettingsComponentPropsContext();
  const { data: customFields = [] } = useFetchCustomFieldsDataContext();
  const { t } = useTranslation();

  return (
    <CustomFieldsSettingsTableStyled isReadOnly={isReadOnly}>
      <TableHeaderCell data-cy="tbl-customfield-name">
        {t('settings:CUSTOM_FIELD_NAME')}
      </TableHeaderCell>
      <TableHeaderCell data-cy="tbl-type">Type</TableHeaderCell>
      <TableHeaderCell data-cy="tbl-mobile">Mobile?</TableHeaderCell>
      <TableHeaderCell data-cy="tbl-facilities">{t('settings:LOCATION')}</TableHeaderCell>
      <TableHeaderCell data-cy="tbl-last-edited">{t('settings:LAST_EDITED')}</TableHeaderCell>
      {!isReadOnly && <TableHeaderCell data-cy="tbl-action">Action</TableHeaderCell>}

      {customFields.length ? (
        customFields.map(
          (
            { id, name, type, facilities, allFacilities, mobile, lastEdited: { date, by } },
            index,
          ) => {
            const isGrey = !!(index % 2);
            return (
              <Fragment key={id}>
                <TableRowCell isGrey={isGrey}>
                  <div
                    style={{
                      wordBreak: 'break-word',
                    }}
                  >
                    {name}
                  </div>
                </TableRowCell>
                <TableRowCell isGrey={isGrey}>
                  {i18next.exists(`settings:${type.toUpperCase()}`)
                    ? t(`settings:${type.toUpperCase()}`)
                    : type}
                </TableRowCell>
                <TableRowCell isGrey={isGrey}>
                  {mobile && <BKJIcon iconName="Checkmark" />}
                </TableRowCell>
                <FacilitiesTableCell
                  isGrey={isGrey}
                  facilitiesList={facilities}
                  isAll={allFacilities}
                />
                <TableRowCell isGrey={isGrey}>{date}</TableRowCell>
                {/* TODO: Add `editedBy` when complex data is done on api */}
                {!isReadOnly ? (
                  <TableRowCell isGrey={isGrey}>
                    <TableRowCellButton
                      variant={'PurpleText'}
                      onClick={() => openEditCustomFieldsModal(`${id}`)}
                    >
                      {t('settings:EDIT')}
                    </TableRowCellButton>
                  </TableRowCell>
                ) : null}
              </Fragment>
            );
          },
        )
      ) : (
        <TableRow isReadOnly={isReadOnly}>
          {isReadOnly ? (
            t(CUSTOM_FIELDS_SETTINGS_NO_CUSTOM_FIELDS_VIEW)
          ) : (
            <span data-cy="msg-link-add-customfield">
              {t(CUSTOM_FIELDS_SETTINGS_NO_CUSTOM_FIELDS_EDIT_1)}&nbsp;
              <InlineBKJButton
                variant="PurpleText"
                onClick={openCreateCustomFieldsModal}
                data-cy="btn-link-add-customfield"
              >
                {t(CUSTOM_FIELDS_SETTINGS_NO_CUSTOM_FIELDS_EDIT_2)}
              </InlineBKJButton>
              &nbsp;
              {t(CUSTOM_FIELDS_SETTINGS_NO_CUSTOM_FIELDS_EDIT_3)}
            </span>
          )}
        </TableRow>
      )}
    </CustomFieldsSettingsTableStyled>
  );
}
